import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BidViewCurrency from '@/components/BidView/BidViewCurrency.vue';
import BidViewPhases from '@/components/BidView/BidViewPhases.vue';
import BidViewDescription from '@/components/BidView/BidViewDescription.vue';
import BidViewQuestions from '@/components/BidView/BidViewQuestions.vue';


// #interfaces
interface IProps {
  isDisabledForm: boolean;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'BidForm',
  props: {
    isDisabledForm: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "bid-form",
    variant: "outlined"
  }, {
    default: _withCtx(() => [
      _createVNode(BidViewCurrency),
      _createVNode(BidViewDescription, {
        "is-disabled-form": __props.isDisabledForm,
        class: "my-7"
      }, null, 8, ["is-disabled-form"]),
      _createVNode(BidViewPhases, {
        "is-disabled-form": __props.isDisabledForm,
        class: "mt-6"
      }, null, 8, ["is-disabled-form"]),
      _createVNode(BidViewQuestions, { "is-disabled-form": __props.isDisabledForm }, null, 8, ["is-disabled-form"])
    ]),
    _: 1
  }))
}
}

})